import { TranslatePipe } from "@ngx-translate/core";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialogClose } from "@angular/material/dialog";

import { OidcAuthenticationConfig } from "../../../app/auth/types";
import { AuthService } from "../../../services/authservice";
import { LoaderComponent } from "../../common/loader/loader";
import { SafeButton } from "../../common/safe-button/safe-button";
import { DialogResultState } from "../components/result-state.component";

export interface BaseProblem {
  description: string;
  email: string;
  fullname: string;
  contact: string;
}

@Component({
  selector: "dialog-report-problem",
  templateUrl: "./dialog-report-problem.html",
  styleUrls: [
    "../dialog-domain-add/dialog-domain-add.scss",
    "../dialog-domain-add/options/domain-option-available/domain-option-available.scss",
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AngularSvgIconModule,
    DialogResultState,
    FormsModule,
    LoaderComponent,
    MatDialogClose,
    SafeButton,
    TranslatePipe,
  ],
})
export class DialogReportProblemComponent {
  private readonly auth = inject(AuthService);
  private readonly oidc = inject(OidcSecurityService);

  public formSubmit = output<BaseProblem>();
  public isResultState = input.required<boolean>();
  public isErrorState = input.required<boolean>();

  protected isAuthenticated = signal(false);
  protected authStateKnown = signal(false);
  protected description = signal("");
  protected email = signal("");
  protected fullname = signal("");
  protected contactOther = signal("");

  protected content = computed<BaseProblem>(() => ({
    description: this.description(),
    email: this.email(),
    fullname: this.fullname(),
    contact: this.contactOther(),
  }));

  constructor() {
    this.auth.userLoaded.subscribe(() => {
      this.email.set(this.auth.currentUser().email);
      this.fullname.set(this.auth.currentUser().displayName);
    });

    this.oidc.isAuthenticated(OidcAuthenticationConfig.Default).subscribe((result) => {
      this.isAuthenticated.set(result);
      this.authStateKnown.set(true);
    });
  }

  protected submit() {
    this.formSubmit.emit(this.content());
  }

  protected openAuthenticationDialog() {
    this.oidc.authorize(OidcAuthenticationConfig.Default);
  }
}
